/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Button, Table } from "antd";
import { FilterOutlined } from "@ant-design/icons";
import { portabilidadeRequest } from "./request";
import { colors } from "../../../../Utils/temas";
import { FiltrosPortabilidade } from "./componentes/filtros";

export const Portabilidade = ({ tab, id }) => {
  const [portabilidade, setPortabilidade] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(null);
  const [filtros, setFiltros] = useState({});

  useEffect(() => {
    if (tab === 5) {
      getPortabilidade(1, 10, id, filtros);
    }
  }, [filtros, tab]);

  const formatacaoData = (data) => {
    if (!data) {
      return "-";
    }

    const date = new Date(data);
    return date.toLocaleString().split(",");
  };

  const getPortabilidade = async (page, pageSize, cartorioId, params) => {
    setLoading(true);
    try {
      const response = await portabilidadeRequest.getPortabilidade(
        page,
        pageSize,
        cartorioId,
        params,
      );

      if (response.status === 200 || response.status === 201) {
        const { results, count } = response.data;
        setPortabilidade(results || []);
        setTotalRecords(count ?? results?.length ?? 0);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Data Portabilidade",
      dataIndex: "data_portabilidade",
      render: (value) => formatacaoData(value),
    },
    { title: "Descrição", dataIndex: "descricao" },
    { title: "Cartório", dataIndex: "cartorio_descricao" },
    { title: "Identificador", dataIndex: "identificador" },
    { title: "Usuário", dataIndex: "nome_usuario" },
  ];

  return (
    <>
      <Table
        dataSource={portabilidade}
        columns={columns}
        loading={loading}
        rowKey="id"
        pagination={{
          total: totalRecords,
          showTotal: (total) => (
            <span
              style={{ fontWeight: "500", position: "absolute", left: "4%" }}
            >
              Quantidade: {total}
            </span>
          ),
          onChange: (page, pageSize) =>
            getPortabilidade(page, pageSize, id, filtros),
        }}
        title={() => (
          <Button
            icon={<FilterOutlined />}
            style={{
              background: colors.secondary,
              color: "white",
              fontWeight: "500",
            }}
            onClick={() => setOpen(true)}
            className="botao"
          >
            Filtros
          </Button>
        )}
      />

      <FiltrosPortabilidade
        visible={open}
        onClose={() => setOpen(false)}
        onFinish={(values) => setFiltros(values)}
        onClear={() => {
          setFiltros({});
          setOpen(false);
        }}
      />
    </>
  );
};
